import { useCallback, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const isBuilderPreview = () =>
    new URLSearchParams(window.location.search).get("builder_preview") === "1";

// Public pages read the published layout. Inside the CRM builder iframe the layout arrives
// over postMessage so edits appear instantly, and clicks travel back to the editor.
export const useSiteLayout = (slug) => {
    const preview = isBuilderPreview();
    const [live, setLive] = useState(null);
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        if (!preview) return;
        const onMessage = (e) => {
            const msg = e.data || {};
            if (msg.type === "rhm-layout") {
                setLive(msg.sections || []);
                setSelectedId(msg.selectedId || null);
            }
        };
        window.addEventListener("message", onMessage);
        window.parent?.postMessage({ type: "rhm-preview-ready" }, "*");
        return () => window.removeEventListener("message", onMessage);
    }, [preview]);

    const { data } = useQuery({
        queryKey: ["site-layout", slug],
        queryFn: async () => (await fetch(`${BASE}/api/site/layout/${slug}`)).json(),
        enabled: !preview,
        staleTime: 30000,
    });

    const onSelect = useCallback((id) => window.parent?.postMessage({ type: "rhm-select", id }, "*"), []);
    const onEditText = useCallback((payload) => window.parent?.postMessage({ type: "rhm-edit-text", payload }, "*"), []);

    return {
        page: data || null,
        sections: preview ? live : data?.sections || null,
        loading: preview ? live === null : data === undefined,
        editing: preview,
        selectedId,
        onSelect,
        onEditText,
    };
};
